import { render, staticRenderFns } from "./Loja.vue?vue&type=template&id=d5c3cb4a"
import script from "./Loja.vue?vue&type=script&lang=js"
export * from "./Loja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports